import type { BookingAfterUnit, StaffOption } from "./types";

export const DEFAULT_BOOKING_AUTO_SEND = true;
export const DEFAULT_BOOKING_AFTER_VALUE = 15;
export const DEFAULT_BOOKING_AFTER_UNIT: BookingAfterUnit = "minutes";
export const DEFAULT_BOOKING_REMINDER_DAYS = 7;

export const MOCK_STAFF: StaffOption[] = [
  {
    id: "1",
    name: "Ivan Pyvovar",
    role: "Front Desk",
    phone: "+1 987-654-3210",
    initials: "IP",
  },
  {
    id: "2",
    name: "Maria Kovalenko",
    role: "Guest Relations",
    phone: "+1 555-010-2030",
    initials: "MK",
  },
];

export const messagingTabsListClassName =
  "h-9 w-full max-w-[820px] items-stretch rounded-lg bg-[#FBFAFF] py-1.5 px-1 gap-1 text-foreground shadow-sm";

export const messagingTabsTriggerClassName =
  "flex flex-1 items-center justify-center self-stretch rounded-md border border-transparent bg-transparent px-2 py-1 text-xs font-medium leading-none text-[#0A0A0A] shadow-none transition-colors hover:bg-[#EDE9FE]/40 data-[state=active]:border-[#C7BCFF] data-[state=active]:bg-[#F2F0FF] data-[state=active]:shadow-none";

export const arrivalChannelTabTriggerClassName =
  "inline-flex h-10 items-center gap-2 rounded-none border-b-2 border-transparent bg-transparent px-3 py-0 text-muted-foreground shadow-none sm:px-4 data-[state=active]:border-royal-glow-3 data-[state=active]:bg-transparent data-[state=active]:text-royal-glow-3 data-[state=active]:shadow-none";
